// A note of the input panels as HTML markup (the HTML writes most of them with innerHTML), in the panel's text; nothing
// for an empty note.
import type { FC } from "react";
import Html from "./Html";

type NoteProps = { html: string };

const Note: FC<NoteProps> = ({ html }) => {
  if (!html) return null;
  return <Html as="div" text={html} />;
};

export default Note;
